import { render, staticRenderFns } from "./CategoryHot.vue?vue&type=template&id=0f856308&"
import script from "./CategoryHot.vue?vue&type=script&lang=js&"
export * from "./CategoryHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports